import api from 'core/util/api';
import { action, observable, runInAction } from 'mobx';

class DeviceSyslogsStatusStore {
  @observable
  fetched = false;

  @observable.ref
  lastFetched: Record<string, boolean> = {};

  @observable.ref
  fetchPromise: Promise<Record<string, boolean>> | null = null;

  @action
  getDeviceSyslogsStatus = () => {
    if (!this.fetchPromise) {
      this.fetchPromise = api.get('/api/ui/devices/syslog/query').then((results: Record<string, boolean>) => {
        runInAction(() => {
          this.fetched = true;
          this.lastFetched = results;
        });
        return results;
      });
    }
    return this.fetchPromise;
  };
}

export const DeviceSyslogsStatus = new DeviceSyslogsStatusStore();
